/**
 * Shared messages used across multiple components and features
 */

/**
 * Gender labels mapping gender enum values to human-readable labels
 * Should match the CharacterGenderSchema from packages/schemas
 */
const genderLabels = {
  male: 'Male',
  female: 'Female',
  gender_neutral: 'Gender Neutral',
} as const;

/**
 * Story theme options mapping theme enum values to human-readable labels
 * Should match the StoryThemesSchema from packages/schemas
 */
const storyThemeOptions = {
  family: 'Family',
  adventure: 'Adventure',
  special_memories: 'Special Memories',
  milestones: 'Milestones',
  new_baby: 'New Baby',
  new_sibling: 'New Sibling',
  holidays: 'Holidays',
  bedtime: 'Bedtime',
  educational: 'Educational',
  love: 'Love',
  custom: 'Custom',
} as const;

/**
 * Common UI labels and messages
 */
export const sharedMessages = {
  // Gender-related
  genderLabels,

  // Story theme options
  storyThemeOptions,

  // Development indicators
  devOnlyIndicator: '(Dev Only)',

  // Common button labels
  commonButtons: {
    back: 'Back',
    next: 'Next',
    cancel: 'Cancel',
    delete: 'Delete',
    save: 'Save',
    create: 'Create',
    edit: 'Edit',
  },

  // Common delete flow messages
  deleteFlow: {
    deleting: 'Deleting...',
  },

  // Common loading states
  loadingStates: {
    makingMagic: 'Making magic...',
  },

  // Add other shared messages here as needed
} as const;
